const routes = {
  //---AUTH---
  login: "/login",

  //---APPLICATION---
  applications: "/applications",
  createApplication: "/create-application",
  updateApplication: "/update-application",

  //---APPLICATION STATUS---
  applicationStatuses: "/application-statuses",
  createApplicationStatus: "/create-application-status",
  updateApplicationStatus: "/update-application-status",

  //---APP NOTIFICATION---
  appNotifications: "/app-notification",
  userNotifications: "/user-notification",
  userNotificationDetails: "/user-notification-details",
  sendNotification: "/send-notification",
  userNotification: "/user-notification",

  //---CLIENT---
  clients: "/clients",
  createClient: "/create-client",
  clientDetails: "/client-details",

  //---SHOP---
  shops: "/shops",
  createShop: "/create-shop",
  shopDetails: "/shop-details",
  invalidSubs: "/invalid-subscriptions",

  //---SUBSCRIPTION---
  subscription: "/subscription",

  //---TRANSACTIONS---
  transactions: "/transactions",

  //---HOME---
  home: "/",

  //DEFAULT
  missing: "*",

  //---OTHER CARDS---
  otherCards: "/other-cards",
  createOtherCard: "/create-other-card",
  updateOtherCard: "/update-other-card",
  otherCardUsage: "/other-card-usage",

  //---CARD BACKGROUND PRESETS---
  cardBackgroundPresets: "/card-background-presets",
  createCardBackgroundPreset: "/create-card-background-preset",
  updateCardBackgroundPreset: "/update-card-background-preset",

  //---RESULT PAGES---
  unauthorized: "/unauthorized",
  error: "/error",
  success: "/success",
};

export default routes;
